import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { devError } from "@/lib/devLog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Loads the leaderboard for a given mode/seed, exposing rows + loading/error
 * state. Re-fetches on dependency change and on manual refresh.
 */
export function useLeaderboard({ mode, seedDate, limit = 10 }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = { limit, mode };
      if (mode === "daily" && seedDate) params.seed_date = seedDate;
      const res = await axios.get(`${API}/leaderboard`, { params });
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      devError("Leaderboard fetch failed", e);
      setError("Could not load leaderboard.");
    } finally {
      setLoading(false);
    }
  }, [mode, seedDate, limit]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { rows, loading, error, refresh };
}
